module.exports = __webpack_public_path__ + "img/hr-construction-robot.75aa9cd8.png";